import apiClient from "../api/client";

export const FournisseurService = {
  // Fournisseurs
  async getFournisseurs(params?: any) {
    const response = await apiClient.get("/fournisseurs/", { params });
    return response;
  },

  async getFournisseur(id: string) {
    const response = await apiClient.get(`/fournisseurs/${id}/`);
    return response;
  },

  async createFournisseur(data: any) {
    const response = await apiClient.post("/fournisseurs/", data);
    return response;
  },

  async updateFournisseur(id: string, data: any) {
    const response = await apiClient.put(`/fournisseurs/${id}/`, data);
    return response;
  },

  async getFournisseurStats(id: string) {
    const response = await apiClient.get(`/fournisseurs/${id}/statistiques/`);
    return response;
  },

  // Documents
  async getDocuments(params?: any) {
    const response = await apiClient.get("/fournisseurs/documents/", { params });
    return response;
  },

  async uploadDocument(data: FormData) {
    const response = await apiClient.post("/fournisseurs/documents/", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },

  // Relations
  async getRelations(params?: any) {
    const response = await apiClient.get("/fournisseurs/relations/", { params });
    return response;
  },
};
